import { tabs } from '../../../../../../views/dashboard/service-provider';

export default {
  tabs: {
    [tabs.general]: 'Yleiset',
    [tabs.restaurant_details]: 'Ravintolan tiedot',
    [tabs.order_conversion]: 'Tilausten konversio',
    [tabs.external_delivery]: 'Ulkoinen toimitus',
    [tabs.mobile_app]: 'Mobiilisovellus',
    [tabs.customer_success_team]: 'Asiakasmenestystiimi',
    [tabs.onboarding_team]: 'Käyttöönottotiimi',
  },
  date_range: {
    this_month: 'Tämä kuukausi',
    last_month: 'Viime kuukausi',
    last_week: 'Viime viikko',
    last_year: 'Viime vuosi',
    this_week: 'Tämä viikko',
    this_year: 'Tämä vuosi',
    today: 'Tänään',
    yesterday: 'Eilen',
    all: 'Kaikki',
  },
};
